<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->
<div class="no-tickets-container">
	<div class="shapes-display-container">
		<div
			automationId="ticketTaskShape"
			class="ticket-edit-container__header-thumbnail shape-background-grey"
		></div>
		<div
			automationId="ticketConstraintShape"
			class="ticket-edit-container__header-thumbnail ticket-thumbnail--constraint shape-background-grey"
		></div>
		<div automationId="ticketMilestoneShape" class="ticket-thumbnail--milestone shape-background-grey"></div>
	</div>

	<div *ngIf="numberOfPlanTickets > 0" class="none-displayed-text">
		<p automationId="mobileNoMatchingTickets">
			{{ strings.NO_MATCHING_TICKETS }}
			<br />
			{{ strings.CHANGE_FILTERS }}
		</p>
	</div>

	<div *ngIf="numberOfPlanTickets === 0" class="none-displayed-text">
		<p automationId="mobileLookingForTickets">
			{{ strings.LOOKING_FOR_TICKETS }}
		</p>
	</div>
</div>
